import Sidebar from '../../components/Sidebar';
import { Header } from '../../components/header';
import { EmployerCertificateContent } from '../../components/employer-certificate-content.component';
import { useState } from 'react';

function EmployerCertificatePage() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='employer-cert'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                {isSidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setIsSidebarOpen(false)}
                    />
                )}

                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />

                    <div className='px-3' style={{ paddingTop: '24px' }}>
                        <EmployerCertificateContent />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default EmployerCertificatePage;
